function validateEmail($email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test($email);
}


flagValidation = true;

function nameValidation(formName) {
    var dataName = formName.find("div[data-validation=name]");
    if (dataName.length) {
        if (dataName.find("input").val() == "") {

            dataName.addClass("custom-error-validation");
            $(".name-validation").remove();
            dataName.append("<div class='name-validation custom-validation'>Lütfen adını gir!</div>");
            flagValidation = false;

        } else if (dataName.find("input").val().length < 2) {

            dataName.addClass("custom-error-validation");
            $(".name-validation").remove();
            dataName.append("<div class='name-validation custom-validation'>Adın en az iki harften oluşmalı!</div>");
            flagValidation = false;

        } else {

            dataName.removeClass("custom-error-validation");
            $(".name-validation").remove();

        }
    }
}


function surnameValidation(formName) {
    var dataSurName = formName.find("div[data-validation=surname]");
    if (dataSurName.length) {
        if (dataSurName.find("input").val() == "") {

            dataSurName.addClass("custom-error-validation");
            $(".surname-validation").remove();
            dataSurName.append("<div class='surname-validation custom-validation'>Lütfen soyadını gir!</div>");
            flagValidation = false;

        } else if (dataSurName.find("input").val().length < 2) {

            dataSurName.addClass("custom-error-validation");
            $(".surname-validation").remove();

            dataSurName.append("<div class='surname-validation custom-validation'>Soyadın en az iki harfli olmalı!</div>");
            flagValidation = false;

        } else {

            dataSurName.removeClass("custom-error-validation");
            $(".surname-validation").remove();

        }
    }
}


function emailValidation(formName) {
    var dataEmail = formName.find("div[data-validation=email]");
    if (dataEmail.length) {
        if (dataEmail.find("input").val() == "") {

            dataEmail.addClass("custom-error-validation");
            $(".email-validation").remove();
            dataEmail.append("<div class='email-validation custom-validation'>Lütfen e-posta adresini gir!</div>");
            flagValidation = false;

        } else if (!validateEmail(dataEmail.find("input").val())) {

            dataEmail.addClass("custom-error-validation");
            $(".email-validation").remove();
            dataEmail.append("<div class='email-validation custom-validation'>Geçersiz e-posta adresi, lütfen tekrar dene!</div>");
            flagValidation = false;

        } else {

            dataEmail.removeClass("custom-error-validation");
            $(".email-validation").remove();

        }
    }
}


function passwordValidation(formName) {
    var dataPassword = formName.find("div[data-validation=password]");
    if (dataPassword.length) {
        if (dataPassword.find("input").val() == "") {

            dataPassword.addClass("custom-error-validation");
            $(".password-validation").remove();
            dataPassword.append("<div class='password-validation custom-validation'>Lütfen şifreni gir!</div>");
            flagValidation = false;

        } else if (dataPassword.find("input").val().length < 6) {

            dataPassword.addClass("custom-error-validation");
            $(".password-validation").remove();
            dataPassword.append("<div class='password-validation custom-validation'>Şifren en az 6 karakterden oluşmalı!</div>");
            flagValidation = false;

        } else {

            dataPassword.removeClass("custom-error-validation");
            $(".password-validation").remove();

        }
    }
}


function checkboxValidation(formName) {
    var dataCheckbox = formName.find("div[data-validation=checkbox]");
    if (dataCheckbox.length) {
        if (!dataCheckbox.find("input").is(":checked")) {

            dataPassword.addClass("custom-error-validation");
            $(".checkbox-validation").remove();

            dataCheckbox.append("<div class='checkbox-validation custom-validation'>Lütfen onayla!</div>");
            flagValidation = false;

        } else {

            dataPassword.addClass("custom-error-validation");
            $(".checkbox-validation").remove();

        }
    }
}

function clearAllValidation() {
    $("form .custom-validation").remove();
}

function userPopupActionValidation(formName) {

    flagValidation = true;

    emailValidation(formName);

    passwordValidation(formName);

    checkboxValidation(formName);


    return flagValidation;

}

function customFormValidation(formName) {

    flagValidation = true;

    nameValidation(formName);

    surnameValidation(formName);

    return flagValidation;


}


